import account from './fr/account';
import damage_report from './fr/damage_report';
import validation from './fr/validation';

export default {
  validation,
  damage_report,
  account
};
